import Api from '../apiWithStatus';
import ApiConstants from '../ApiConstants';

const validateUsername = (payload, token) => {
    return Api(
        `${ApiConstants.VALIDATION_USERNAME}`,
        payload,
        'post',
        null,
        null,
    );
}
const checkPatientExists = (payload, token) => {
    return Api(
        `${ApiConstants.PATIENT_EXIST_CHECK}`,
        payload,
        'post',
        null,
        null,
    );
}
const verifyCode = (payload) => {
    return Api(
        `${ApiConstants.VERIFY_CODE}`,
        payload,
        'post',
        null,
    );
}
const validateUser = (query, token) => {
    return Api(ApiConstants.VALIDATE_PATIENT_EMAIL_PHONE + '?' + query, null, 'get', null);
}
const registerUserV2 = (payload) => {
    return Api(ApiConstants.REGISTER_USER_V2, payload, 'post', null);
};

export {
    validateUsername,
    checkPatientExists,
    verifyCode,
    validateUser,
    registerUserV2
}